import {Action, getModule, Module, Mutation, VuexModule} from "@/node_modules/vuex-module-decorators";
import store from "@/classes/core/store";
import ManagerApi from "@/classes/app/api/manager-api";
import {appAuthModule} from "@/store/app/auth";
import VarUtil from "@/classes/utils/var-util";
import {$apm} from "@/classes/app/app-manager";

export interface IShopStaff {
    toid: string;
    title: string;
    body: string;
    is_active: string;
    related_twitter: number;
    related_facebook: number;
    published_at: string;
    created_at: string;
    updated_at: string;
    categories?: string[];
}

export interface IShopStaffFilter {
    type?: string;
    status?: number;
    word?: string;
    date?: string;
}

export interface IManagerShopStaffModule {
    fetched: boolean;
    filter: any;
    page: number;
    info: any;
    records: IShopStaff[];
}

@Module({dynamic: true, store, name: 'managerShopStaff', namespaced: true})
class Store extends VuexModule implements IManagerShopStaffModule {

    public fetched: boolean = false;
    public filter: any = {
        type: 'blog',
        word: '',
        status: null,
        date: '',
    };
    public page: number = 1;
    public info: any;
    public records: IShopStaff[] = [];

    @Mutation
    public updateRecords(value: IShopStaff[]) {
        this.records = value;
    }

    @Mutation
    public updateFilter(filter: IShopStaffFilter) {
        this.filter = Object.assign({}, M.filter, filter);
    }

    @Mutation
    public updateArticle(value: IShopStaff) {
        this.records = Array.from(this.records).map((_: IShopStaff) => {
            return (_.toid === value.toid) ?
                Object.assign({}, _, value) : _;
        });
    }

    @Mutation
    public updateFetched(fetched: boolean) {
        this.fetched = fetched;
    }

    @Action
    public async resetFilter() {
        M.updateFilter({
            status: 0,
            word: '',
            date: '',
        });
    }

    @Action
    public async fetch(force: boolean = false): Promise<any> {

        if (!force && M.fetched) {
            return;
        }

        try {
            const records = await ManagerApi.ShopStaff.get(Object.assign({
                site: $apm.siteid,
                page: M.page
            }, M.filter)).execAsync('records.list');

            // console.log('managerShopStaffModule.fetch() > records > ', records);

            M.updateRecords(records || []);
            M.updateFetched(true);

            return null;
        } catch (e) {
            return e;
        }
    }

    @Action
    public async create(): Promise<any> {
        try {
            await ManagerApi.ShopStaff.post()
                .execAsync();
        } catch (e) {
            console.error('Error > ', e);
        }
    }

    @Action
    public async save(record: any): Promise<any> {
        try {
            await ManagerApi.ShopStaff.put(record.toid, record).execAsync();
        } catch (e) {
            console.error('Error > ', e);
        }
    }

    @Action
    public async post(param: any): Promise<any> {
        try {
            return await ManagerApi.ShopStaff.post(param).execAsync('record');
        } catch (e) {
            console.error('Error > ', e);
        }

        return null;
    }
}

export const managerShopStaffModule = getModule(Store);

const M = managerShopStaffModule;
